var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgProgressClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.577 9.517a.933.933 0 0 0-1.32-1.32l1.32 1.32zM7.423 14.03a.933.933 0 0 0 1.32 1.32l-1.32-1.32zm5.834 1.32a.933.933 0 1 0 1.32-1.32l-1.32 1.32zM8.743 8.197a.933.933 0 1 0-1.32 1.32l1.32-1.32zm9.574 3.576A7.317 7.317 0 0 1 11 19.09v1.867a9.183 9.183 0 0 0 9.183-9.184h-1.866zM11 19.09a7.317 7.317 0 0 1-7.317-7.317H1.817A9.183 9.183 0 0 0 11 20.957V19.09zm-7.317-7.317A7.317 7.317 0 0 1 11 4.457V2.59a9.183 9.183 0 0 0-9.183 9.183h1.866zM11 4.457a7.317 7.317 0 0 1 7.317 7.316h1.866A9.183 9.183 0 0 0 11 2.59v1.867zm2.257 3.74-2.917 2.917 1.32 1.32 2.917-2.917-1.32-1.32zm-2.917 2.917L7.423 14.03l1.32 1.32 2.917-2.917-1.32-1.32zm4.237 2.916-2.917-2.916-1.32 1.32 2.917 2.916 1.32-1.32zm-2.917-2.916L8.743 8.197l-1.32 1.32 2.917 2.916 1.32-1.32z",
    fill: "#10121C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProgressClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ProgressClose.b81f5c58.svg";
export { ForwardRef as ReactComponent };